import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DialogService} from 'src/app/services/dialog.service';
import {AlertDialogParams} from '../../alert-dialog/alert-dialog.component';
import UnitAccountProvider from 'src/app/shared/enums/UnitAccountProvider.enum';

@Component({
  selector: 'terra-unit-bank-sticky-footer',
  templateUrl: './unit-bank-sticky-footer.component.html',
  styleUrls: ['./unit-bank-sticky-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankStickyFooterComponent implements OnInit {

  @Input() bankingProviderString: string;
  @Input() accountProvider: UnitAccountProvider;

  UnitAccountProvider = UnitAccountProvider;

  constructor(
    private dialogService: DialogService
  ) {
  }

  ngOnInit(): void {
  }

  openDialog() {
    const data = new AlertDialogParams();
    data.title = 'Covercy Legal Terms';
    data.description = `Covercy is a financial technology company and is not a bank. Banking services provided by Thread Bank; Member FDIC. The Covercy Visa Debit & Charge Cards are issued by Thread Bank pursuant to a license from Visa U.S.A. Inc. and may be used everywhere Visa cards are accepted.

    Your deposits qualify for up to a maximum of $3,000,000 in FDIC insurance coverage when placed at program banks in the Thread Bank deposit sweep program.

    Your deposits at each program bank become eligible for FDIC insurance up to $250,000, inclusive of any other deposits you may already hold at the bank in the same ownership capacity.

    You can access the terms and conditions of the sweep program at <a target="_blank" href="https://thread.bank/sweep-disclosure/">https://thread.bank/sweep-disclosure/</a> and a list of program banks at <a target="_blank" href="https://thread.bank/program-banks/">https://thread.bank/program-banks/</a> with questions on the program.

    Please contact <a target="_blank" href="mailto:customerservice@thread.bank">customerservice@thread.bank</a> with questions on the sweep program.`;

    data.showAction = false;
    data.panelClass = 'unit-bank-sticky-footer-dialog';

    this.dialogService.alertDialog(data);
  }

}
